import { StorageItemProcessor } from '@vsolv/packages/storage/domain';
import { ThemeColorEnum } from '@vsolv/vectors-ui/theming';

export function isNotNull<T>(item: T | null): item is T {
  return item !== null;
}

export function statusBadgeConfig(processingResults?: StorageItemProcessor.Result[]) {
  // Only consider the most recent result of each processor
  const results = [...(processingResults || [])]
    .sort((a, b) => b.created.getTime() - a.created.getTime())
    .filter((r, i, a) => i === a.findIndex(rr => rr.processorId === r.processorId));

  const status = !results.length
    ? null
    : results.some(({ status }) => status === StorageItemProcessor.OutputStatus.FAILED)
      ? StorageItemProcessor.OutputStatus.FAILED
      : results.some(({ status }) => status === StorageItemProcessor.OutputStatus.PROCESSING)
        ? StorageItemProcessor.OutputStatus.PROCESSING
        : StorageItemProcessor.OutputStatus.PROCESSED;

  return {
    status,
    text: status ? status[0] + status.toLowerCase().slice(1) : 'Not processed',
    theme: status
      ? {
          [StorageItemProcessor.OutputStatus.FAILED]: ThemeColorEnum.danger,
          [StorageItemProcessor.OutputStatus.PROCESSING]: ThemeColorEnum.info,
          [StorageItemProcessor.OutputStatus.PROCESSED]: ThemeColorEnum.success,
        }[status]
      : ThemeColorEnum.default,
  };
}
